import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PersonalConstants } from 'app/common/personalConstants';
import { ROUTING } from 'app/common/routeConstants';
import { Analytics } from 'app/shared/models/analytics.model';
import { Address } from 'app/shared/models/claims-efnol-questions.model';
import { OysRepairShop } from 'app/shared/models/oys.model';
import { EnvironmentpickerService } from 'app/shared/services/environmentpicker.service';
import { HttpHeaderService } from 'app/shared/services/httpheader.service';
import { LoggerService } from 'app/shared/services/logger.service';
import { SessionService } from 'app/shared/services/session.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'is-oys-tracker-shop-select',
    templateUrl: './oys-tracker-shop-select.component.html',
    styleUrls: ['./oys-tracker-shop-select.component.scss'],
    standalone: false
})
export class OysTrackerShopSelectComponent implements OnInit {
    breadCrumbs!: BreadCrumb[];
    homeIconLink = environment.NATIONWIDE.HOME;
    clientId = environment.appProps.appClientId;
    currentPage = 'Find a repair shop';
    env!: string;
    accessToken!: string;
    selectedRepairFacility?: OysRepairShop;
    claimId?: string;
    externalClaimId?: string;
    vehicleIncidentId?: string;
    isLoading = true;
    showError = false;
    vehicleLocation!: Address;

    constructor(
        private environmentpickerService: EnvironmentpickerService,
        private httpHeader: HttpHeaderService,
        public sessionService: SessionService,
        private logger: LoggerService,
        private router: Router
    ) {}

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: any): any {
        this.logger.logCurrentContents();
    }

    ngOnInit(): void {
        this.claimId = sessionStorage.getItem('oysTrackerClaimId') || undefined;
        this.externalClaimId = sessionStorage.getItem('oysExternalClaimId') || undefined;
        this.vehicleIncidentId = sessionStorage.getItem('trackerVehicleIncidentId') || undefined;
        this.setBreadCrumbs();
        this.logger.setPageName('oysTrackerShopSelect');
        this.env = environment.CLAIMS_DEV ? this.environmentpickerService.getEnvironmentCookie() : 'prod';
        this.accessToken = this.httpHeader.getAccessToken();
        this.vehicleLocation = this.sessionService.getSessionItemDecrypted('vehicleLocation');
        this.isLoading = false;
        this.logger.info('OYS Tracker Shop Select: Page loaded', {
            environment: this.env,
            policyNumber: this.sessionService.getPolicyNumber()
        });
    }

    setBreadCrumbs(): void {
        this.homeIconLink = environment.NATIONWIDE.HOME;
        const policyNumber = this.sessionService.getPolicyNumber();
        this.breadCrumbs = [
            {
                name: 'All accounts',
                link: `${environment.CLAIMS_OLD_APP.ALL_ACCOUNTS}${PersonalConstants.CLAIMS_OLD_URLS.ACCOUNT_SUMMARY_PAGE}`
            },
            {
                name: 'Auto claims',
                link: `${environment.CLAIMS_NEW_APP.BASE_URL}${PersonalConstants.CLAIMS_URLS.CLAIM_LIST_PAGE}?policyNumber=${encodeURIComponent(policyNumber)}`
            },
            {
                name: 'Track your claim',
                link: `${ROUTING.AUTO.BASE_PATH}/${ROUTING.AUTO.CHILD_PATH_TRACKER}`
            }
        ];
    }

    shopDetails(shop: any): void {
        this.selectedRepairFacility = shop;
        this.isLoading = false;
        this.showError = false;
        this.logger.info('Shop selected from find-repair-shop', {
            shop: this.selectedRepairFacility,
            keys: this.selectedRepairFacility ? Object.keys(this.selectedRepairFacility) : []
        });
    }

    continue(): void {
        if (this.selectedRepairFacility) {
            this.showError = false;
            sessionStorage.setItem('oysTrackerSelectedShop', JSON.stringify(this.selectedRepairFacility));
            this.logger.info('OYS Tracker Shop Select: Continue clicked with shop selected');
            this.router.navigate([
                ROUTING.AUTO.BASE_PATH,
                ROUTING.AUTO.CHILD_PATH_TRACKER,
                ROUTING.AUTO.CHILD_PATH_OYS_SHOP_CONFIRM
            ]);
        } else {
            this.showError = true;
            this.logger.info('OYS Tracker Shop Select: Continue clicked without shop selected');
        }
    }

    onCancel(): void {
        this.logger.info('OYS Tracker Shop Select: Cancel clicked');
        this.router.navigate([ROUTING.AUTO.BASE_PATH, ROUTING.AUTO.CHILD_PATH_TRACKER]);
    }

    handleAnalytics(analytics: Analytics): void {
        this.logger.info(analytics.name, analytics.value);
    }

    handleError(component: string, error: any): void {
        this.isLoading = false;
        this.logger.error(`Claims Component Error`, error, { component: component });
    }
}
